import { useMemo } from "react";
import { ConcreteLoginStrategy, LoginStrategy } from "./LoginStrategy";
import { useIsMobile, useIsMobileWebView } from "shared-ts-utils-ua-parser";

export const useResolveLoginStrategy = (
  strategy: LoginStrategy | undefined
): ConcreteLoginStrategy => {
  let forcedLoginStrategy: string | null = null;
  try {
    forcedLoginStrategy = localStorage.getItem("loginStrategy");
  } catch (e) {
    console.warn("Could not read loginStrategy from localStorage", e);
  }

  const isMobile = useIsMobile();
  const isMobileWebView = useIsMobileWebView();
  return useMemo(() => {
    if (
      forcedLoginStrategy != null &&
      (forcedLoginStrategy === "pageSubmit" ||
        forcedLoginStrategy === "api" ||
        forcedLoginStrategy === "mobileWebView")
    ) {
      return forcedLoginStrategy;
    }

    const desired = strategy ?? "auto";
    if (desired !== "auto") return desired;
    if (isMobileWebView) {
      return "mobileWebView";
    } else if (isMobile) {
      return "pageSubmit";
    }
    return "api";
  }, [forcedLoginStrategy, isMobileWebView, isMobile, strategy]);
};
